import { Fragment } from 'react';

/**
 * Simple 2-step stepper for the signup flow.
 * Step 1 = account details. Step 2 = payment.
 *
 * Implementation note: we render a list of <li> elements with <span>
 * connectors between them. React fragments are keyed with <Fragment key>
 * here (not <>...</>) because short-syntax fragments can't carry a key.
 */
export function Stepper({ current }) {
  const steps = [
    { n: 1, label: 'Account' },
    { n: 2, label: 'Payment' },
  ];

  return (
    <ol className="stepper" aria-label="Signup progress" style={{ listStyle: 'none', padding: 0 }}>
      {steps.map((s, i) => {
        const state = s.n < current ? 'done' : s.n === current ? 'active' : '';
        return (
          <Fragment key={s.n}>
            <li className={`step ${state}`} aria-current={s.n === current ? 'step' : undefined}>
              <span className="step-dot" aria-hidden="true">{s.n < current ? '✓' : s.n}</span>
              <span className="step-label">{s.label}</span>
            </li>
            {i < steps.length - 1 && <span className="step-connector" aria-hidden="true" />}
          </Fragment>
        );
      })}
    </ol>
  );
}
